<!-- `role="status"` + `aria-live` anunciam o carregamento uma vez; as barras são
     decoração e ficam fora da árvore de acessibilidade. -->
<div class="skeleton" [class.skeleton--reduced-motion]="reducedMotion" role="status" aria-live="polite"
  data-testid="skeleton">

  <span class="skeleton__announce">{{ label }}</span>

  <ng-container [ngSwitch]="variant">

    <!-- Cartão vem em fileira porque é assim que os blocos de número aparecem
         nas telas; abaixo de ~200px por cartão a fileira quebra sozinha. -->
    <div class="skeleton__cards" *ngSwitchCase="'card'">
      <div class="skeleton__card" *ngFor="let row of rows" aria-hidden="true" data-testid="skeleton-card">
        <span class="skeleton__bar skeleton__bar--label"></span>
        <span class="skeleton__bar skeleton__bar--number"></span>
        <span class="skeleton__bar skeleton__bar--hint"></span>
      </div>
    </div>

    <ng-container *ngSwitchCase="'table-row'">
      <div class="skeleton__row" *ngFor="let row of rows" aria-hidden="true" data-testid="skeleton-table-row">
        <span class="skeleton__bar skeleton__cell" *ngFor="let cell of cells"></span>
      </div>
    </ng-container>

    <!-- `text` é o padrão: qualquer variante desconhecida cai em linha de texto,
         que é o esqueleto menos errado para conteúdo qualquer. -->
    <ng-container *ngSwitchDefault>
      <span class="skeleton__bar skeleton__bar--text" *ngFor="let row of rows; let last = last"
        [class.skeleton__bar--short]="last && rows.length > 1" aria-hidden="true" data-testid="skeleton-text"></span>
    </ng-container>

  </ng-container>
</div>
